import { useEffect, useState } from 'react';
import getAFOneLinkConfig from '../utils/getAFOneLinkConfig';

const oneLinkFallback = 'https://alltrails.onelink.me/EFvD/hvsmar15';

type UseDeepLinkParams = {
  pageType?: 'area' | 'trail';
  pageId?: number;
  isOpen?: boolean;
};

const useDeeplink = ({ pageType, pageId, isOpen }: UseDeepLinkParams) => {
  const [deeplink, setDeeplink] = useState(oneLinkFallback);

  useEffect(() => {
    let appPath = 'screen/explore';

    if (pageType && pageId) {
      appPath = `${pageType}/${pageId}`;
    }

    if (isOpen) {
      const createOneLink = () => {
        if (window.AF_SMART_SCRIPT) {
          const resultUrl = window.AF_SMART_SCRIPT.generateOneLinkURL(getAFOneLinkConfig(appPath));

          if (resultUrl?.clickURL) {
            setDeeplink(resultUrl.clickURL);

            // Timeout required according to AF documentation.
            // https://dev.appsflyer.com/hc/docs/dl_smart_script_v2#fire-an-impression
            setTimeout(() => {
              window.AF_SMART_SCRIPT.fireImpressionsLink();
            }, 1000);
          }
        }
      };

      if (window.AF_SMART_SCRIPT) {
        createOneLink();
      } else {
        const onelinkScript = document.querySelector('#af-onelink-script');
        if (onelinkScript) {
          onelinkScript.addEventListener('load', () => {
            if (window.AF_SMART_SCRIPT) {
              createOneLink();
            }
          });
        }
      }
    }
  }, [pageId, pageType, isOpen]);

  return deeplink;
};

export default useDeeplink;
